/**
 * search.js
 * Provides fetchAndUpdateSearch and goToSelectedItem
 * for use with Alpine.js v3 in the Bumble Beez theme header.
 */

/**
 * Fetch predictive search results from Shopify's API
 * and update the Alpine searchItems array.
 */
async function fetchAndUpdateSearch(event, params, resources) {
  const query = event.target.value.trim();

  // Get the Alpine component root (the <header> element)
  const header = document.querySelector('header[x-data]');
  if (!header) return;
  const alpine = Alpine.$data(header);

  // Clear results if query is empty
  if (!query) {
    alpine.searchItems = [];
    return;
  }

  // Build resource types string
  const resourceTypes = Object.entries(resources)
    .filter(([, enabled]) => enabled)
    .map(([type]) => type)
    .join(',');

  // Build search fields string
  const searchFields = Object.entries(params)
    .filter(([key, val]) => val === true)
    .map(([key]) => key)
    .join(',');

  const url = new URL('/search/suggest.json', window.location.origin);
  url.searchParams.set('q', query);
  url.searchParams.set('resources[type]', resourceTypes);
  url.searchParams.set('resources[options][fields]', searchFields);
  url.searchParams.set('resources[limit]', '4');

  try {
    const response = await fetch(url.toString(), {
      headers: { 'Content-Type': 'application/json' }
    });
    if (!response.ok) throw new Error('Search request failed');

    const data = await response.json();
    alpine.searchItems = data.resources?.results?.products || [];
  } catch (err) {
    console.error('Predictive search error:', err);
    alpine.searchItems = [];
  }
}

/**
 * Navigate to the search results page
 * based on the current input value in the form.
 */
function goToSelectedItem(formEl) {
  const input = formEl.closest('form')?.querySelector('input[name="q"]')
    || document.querySelector('input[name="q"]');

  const query = input?.value?.trim();
  if (!query) return;

  window.location.href = `/search?q=${encodeURIComponent(query)}&type=product,page,article`;
}
